var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-link',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"href":_vm.authorUrl,"title":_vm.showAuthorName ? null : _vm.author.name}},[_c('gl-avatar',{attrs:{"src":_vm.avatarUrl,"size":16,"alt":_vm.author.name}}),(_vm.showAuthorName)?_c('span',{staticClass:"author gl-ml-2"},[_vm._v(_vm._s(_vm.author.name))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }